import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const AppointmentWizard = lazy(() => import(/* webpackChunkName: "AppointmentWizard" */ './components/AppointmentWizard'));

const appointmentWizard = document.getElementById('appointment-wizard');
if (appointmentWizard != null) {
    const props = parseDatasetToProps(appointmentWizard.dataset);

    render(
        <Suspense fallback={<></>}>
            <AppointmentWizard
                {...props}
            />
        </Suspense>,
        appointmentWizard
    );
}
